import { ApiResponse } from '../types/api'
import { UserRole } from '../stores/authStore'

// 模拟延迟
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

// 模拟用户数据
const mockUsers = [
  {
    id: '1',
    username: 'admin',
    email: 'admin@novelai.com',
    role: UserRole.SUPER_ADMIN,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=admin',
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    username: 'author1',
    email: 'author1@novelai.com',
    role: UserRole.WRITER,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=author1',
    createdAt: '2024-01-15T00:00:00Z',
  },
  {
    id: '3',
    username: 'reader1',
    email: 'reader1@novelai.com',
    role: UserRole.READER,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=reader1',
    createdAt: '2024-02-01T00:00:00Z',
  },
]

// 模拟小说数据
const mockNovels: any[] = [
  {
    id: '1',
    title: '星辰变',
    author: '我吃西红柿',
    description: '一部经典的修仙小说，讲述了一个平凡少年凭借毅力与智慧，在修真世界中逐步成长的故事。',
    chapters: 15,
    status: 'publishing',
    style: 'xianxia',
    coverImage: 'https://picsum.photos/seed/novel1/300/400',
    createdAt: '2024-03-01T00:00:00Z',
    updatedAt: '2024-04-22T14:30:00Z',
  },
  {
    id: '2',
    title: '斗破苍穹',
    author: '天蚕土豆',
    description: '斗气大陆的传奇故事，废柴少年逆袭成为大陆强者的热血冒险。',
    chapters: 24,
    status: 'publishing',
    style: 'xuanhuan',
    coverImage: 'https://picsum.photos/seed/novel2/300/400',
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-04-21T10:15:00Z',
  },
  {
    id: '3',
    title: '凡人修仙传',
    author: '忘语',
    description: '一个普通凡人踏入修仙界的坎坷历程。',
    chapters: 8,
    status: 'draft',
    style: 'xianxia',
    coverImage: 'https://picsum.photos/seed/novel3/300/400',
    createdAt: '2024-03-20T00:00:00Z',
    updatedAt: '2024-04-20T16:45:00Z',
  },
  {
    id: '4',
    title: '诡秘之主',
    author: '爱潜水的乌贼',
    description: '穿越到异世界的少年探寻诡秘力量的冒险之旅。',
    chapters: 32,
    status: 'completed',
    style: 'qihuan',
    coverImage: 'https://picsum.photos/seed/novel4/300/400',
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-04-19T09:20:00Z',
  },
]

// 模拟章节数据
const mockChapters: any[] = [
  { id: 'c1', novelId: '1', title: '第一章 星辰之初', number: 1, wordCount: 3240, status: 'published', content: '这是一个关于星辰的故事...', createdAt: '2024-03-01T10:00:00Z', updatedAt: '2024-03-01T10:00:00Z' },
  { id: 'c2', novelId: '1', title: '第二章 命运之轮', number: 2, wordCount: 4560, status: 'published', content: '命运开始转动...', createdAt: '2024-03-05T14:30:00Z', updatedAt: '2024-03-05T14:30:00Z' },
  { id: 'c3', novelId: '1', title: '第三章 暗流涌动', number: 3, wordCount: 3890, status: 'completed', content: '暗流开始涌动...', createdAt: '2024-03-10T09:15:00Z', updatedAt: '2024-03-10T09:15:00Z' },
  { id: 'c4', novelId: '1', title: '第四章 新篇章', number: 4, wordCount: 2100, status: 'writing', content: '新篇章开启...', createdAt: '2024-04-01T16:00:00Z', updatedAt: '2024-04-01T16:00:00Z' },
  { id: 'c5', novelId: '2', title: '第一章 陨落的天才', number: 1, wordCount: 5120, status: 'published', content: '曾经的天才少年...', createdAt: '2024-03-15T08:00:00Z', updatedAt: '2024-03-15T08:00:00Z' },
  { id: 'c6', novelId: '2', title: '第二章 重燃希望', number: 2, wordCount: 4780, status: 'published', content: '希望重新燃起...', createdAt: '2024-03-20T11:30:00Z', updatedAt: '2024-03-20T11:30:00Z' },
  { id: 'c7', novelId: '2', title: '第三章 试炼之路', number: 3, wordCount: 6340, status: 'draft', content: '试炼之路充满艰险...', createdAt: '2024-04-01T10:00:00Z', updatedAt: '2024-04-01T10:00:00Z' },
]

// 扩展的 mock 用户数据（带 status 字段）
const extendedMockUsers = [
  {
    id: '1',
    username: 'admin',
    email: 'admin@novelai.com',
    role: UserRole.SUPER_ADMIN,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=admin',
    status: 'active',
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    username: 'author1',
    email: 'author1@novelai.com',
    role: UserRole.WRITER,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=author1',
    status: 'active',
    createdAt: '2024-01-15T00:00:00Z',
  },
  {
    id: '3',
    username: 'reader1',
    email: 'reader1@novelai.com',
    role: UserRole.READER,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=reader1',
    status: 'active',
    createdAt: '2024-02-01T00:00:00Z',
  },
  {
    id: '4',
    username: 'author2',
    email: 'author2@novelai.com',
    role: UserRole.WRITER,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=author2',
    status: 'active',
    createdAt: '2024-02-15T00:00:00Z',
  },
  {
    id: '5',
    username: 'reader2',
    email: 'reader2@novelai.com',
    role: UserRole.READER,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=reader2',
    status: 'disabled',
    createdAt: '2024-03-01T00:00:00Z',
  },
  {
    id: '6',
    username: 'admin2',
    email: 'admin2@novelai.com',
    role: UserRole.ADMIN,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=admin2',
    status: 'active',
    createdAt: '2024-03-10T00:00:00Z',
  },
]

// 模拟系统监控数据
const mockSystemMonitoringData = {
  services: [
    { name: 'User', status: 'healthy', uptime: '15天 3小时', latency: 42, lastChecked: new Date().toISOString() },
    { name: 'Novel', status: 'healthy', uptime: '15天 3小时', latency: 68, lastChecked: new Date().toISOString() },
    { name: 'Creation', status: 'healthy', uptime: '15天 2小时', latency: 125, lastChecked: new Date().toISOString() },
    { name: 'KG', status: 'degraded', uptime: '12天 7小时', latency: 320, lastChecked: new Date().toISOString() },
    { name: 'Vector', status: 'healthy', uptime: '15天 3小时', latency: 55, lastChecked: new Date().toISOString() },
    { name: 'Gateway', status: 'healthy', uptime: '15天 3小时', latency: 12, lastChecked: new Date().toISOString() },
  ],
  metrics: {
    requestsPerMinute: 2340,
    errorRate: 1.2,
    avgResponseTime: 156,
    requestTrend: 'up',
    errorTrend: 'down',
    responseTrend: 'stable',
  },
  resources: {
    cpu: 45,
    memory: 62,
    connections: 38,
    maxConnections: 100,
    diskUsage: 55,
  },
  timestamp: new Date().toISOString(),
}

// 模拟API响应
const createMockResponse = <T>(data: T, success: boolean = true): ApiResponse<T> => ({
  success,
  data,
  message: success ? '请求成功' : '请求失败',
  timestamp: new Date().toISOString(),
})

// 认证API模拟
export const mockAuthApi = {
  login: async (username: string, password: string) => {
    await delay(800)
    
    const user = mockUsers.find(u => u.username === username || u.email === username)
    
    if (!user || password !== 'test123456') {
      throw new Error('用户名或密码错误')
    }
    
    return createMockResponse({
      access_token: `mock_access_token_${user.id}`,
      refresh_token: `mock_refresh_token_${user.id}`,
      user,
    })
  },
  
  logout: async () => {
    await delay(300)
    return createMockResponse({ message: '登出成功' })
  },
  
  getCurrentUser: async () => {
    await delay(500)
    // 返回第一个用户作为当前用户
    return createMockResponse(mockUsers[0])
  },
  
  refreshToken: async (_refreshToken: string) => {
    await delay(500)
    return createMockResponse({
      access_token: 'new_mock_access_token',
      refresh_token: 'new_mock_refresh_token',
    })
  },
  
  ssoCallback: async (token: string) => {
    await delay(800)
    return createMockResponse({
      access_token: `sso_access_token_${token}`,
      refresh_token: `sso_refresh_token_${token}`,
      user: mockUsers[1], // 返回作者用户
    })
  },
}

// 仪表盘API模拟
export const mockDashboardApi = {
  getDashboardStats: async () => {
    await delay(600)
    return createMockResponse({
      totalNovels: 42,
      totalChapters: 156,
      activeAuthors: 8,
      pendingTasks: 3,
      recentNovels: mockNovels,
      systemStatus: {
        aiService: true,
        database: true,
        knowledgeGraph: true,
        agentWorkflow: true,
      },
      creationProgress: [
        { novelId: '1', title: '星辰变', progress: 65, color: '#1890ff' },
        { novelId: '2', title: '斗破苍穹', progress: 42, color: '#52c41a' },
        { novelId: '3', title: '凡人修仙传', progress: 18, color: '#faad14' },
      ],
    })
  },
  
  getQuickActions: async () => {
    await delay(400)
    return createMockResponse([
      {
        id: '1',
        title: '新建作品',
        description: '开始创作新的小说',
        icon: 'PlusOutlined',
        color: 'blue',
        path: '/creation/novels/new',
      },
      {
        id: '2',
        title: '管理章节',
        description: '查看和编辑所有章节',
        icon: 'FileTextOutlined',
        color: 'green',
        path: '/creation/chapters',
      },
      {
        id: '3',
        title: '角色设定',
        description: '管理角色和关系',
        icon: 'UserOutlined',
        color: 'purple',
        path: '/creation/characters',
      },
      {
        id: '4',
        title: '创作任务',
        description: '查看和管理AI创作任务',
        icon: 'BarChartOutlined',
        color: 'orange',
        path: '/creation/tasks',
      },
    ])
  },
  
  getNotifications: async (_limit: number = 10) => {
    await delay(500)
    return createMockResponse([
      {
        id: '1',
        title: '您有新的作品评论',
        message: '《星辰变》第15章收到新的评论',
        type: 'info',
        timestamp: '2024-04-22T14:25:00Z',
        read: false,
      },
      {
        id: '2',
        title: '系统维护通知',
        message: '系统将于今晚24:00进行维护',
        type: 'warning',
        timestamp: '2024-04-22T10:30:00Z',
        read: true,
      },
      {
        id: '3',
        title: '欢迎使用NovelAI',
        message: '感谢您选择我们的创作平台',
        type: 'success',
        timestamp: '2024-04-21T09:15:00Z',
        read: true,
      },
    ])
  },
}

// 小说管理API模拟
export const mockNovelApi = {
  getNovels: async (page: number = 1, pageSize: number = 10) => {
    await delay(700)
    return createMockResponse({
      items: mockNovels,
      total: mockNovels.length,
      page,
      pageSize,
      totalPages: 1,
      hasNext: false,
      hasPrev: false,
    })
  },
  
  getNovel: async (id: string) => {
    await delay(500)
    const novel = mockNovels.find(n => n.id === id)
    if (!novel) throw new Error('小说不存在')
    return createMockResponse(novel)
  },
  
  createNovel: async (data: any) => {
    await delay(800)
    const newNovel = {
      id: `mock_${Date.now()}`,
      ...data,
      chapters: 0,
      status: 'draft',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }
    mockNovels.push(newNovel)
    return createMockResponse(newNovel)
  },
  
  updateNovel: async (id: string, data: any) => {
    await delay(600)
    const index = mockNovels.findIndex(n => n.id === id)
    if (index === -1) throw new Error('小说不存在')
    
    mockNovels[index] = {
      ...mockNovels[index],
      ...data,
      updatedAt: new Date().toISOString(),
    }
    
    return createMockResponse(mockNovels[index])
  },
  
  deleteNovel: async (id: string) => {
    await delay(500)
    const index = mockNovels.findIndex(n => n.id === id)
    if (index === -1) throw new Error('小说不存在')
    
    mockNovels.splice(index, 1)
    return createMockResponse({ message: '删除成功' })
  },
}

// 系统监控API模拟
export const mockSystemApi = {
  getMonitoringData: async () => {
    await delay(600)
    return createMockResponse(mockSystemMonitoringData)
  },
}

// 用户管理API模拟
export const mockUserApi = {
  getUsers: async (params: any) => {
    await delay(600)
    let filtered = [...extendedMockUsers]

    // 过滤
    if (params?.username) {
      filtered = filtered.filter((u) =>
        u.username.toLowerCase().includes(params.username.toLowerCase())
      )
    }
    if (params?.email) {
      filtered = filtered.filter((u) =>
        u.email.toLowerCase().includes(params.email.toLowerCase())
      )
    }
    if (params?.role) {
      filtered = filtered.filter((u) => u.role === params.role)
    }

    const page = params?.page || 1
    const pageSize = params?.pageSize || 10
    const start = (page - 1) * pageSize
    const items = filtered.slice(start, start + pageSize)

    return createMockResponse({
      items,
      total: filtered.length,
      page,
      pageSize,
      totalPages: Math.ceil(filtered.length / pageSize),
    })
  },

  updateUser: async (id: string, data: any) => {
    await delay(500)
    const index = extendedMockUsers.findIndex((u) => u.id === id)
    if (index === -1) throw new Error('用户不存在')

    extendedMockUsers[index] = {
      ...extendedMockUsers[index],
      ...data,
      updatedAt: new Date().toISOString(),
    }

    return createMockResponse(extendedMockUsers[index])
  },

  deleteUser: async (id: string) => {
    await delay(400)
    const index = extendedMockUsers.findIndex((u) => u.id === id)
    if (index === -1) throw new Error('用户不存在')

    extendedMockUsers.splice(index, 1)
    return createMockResponse({ message: '删除成功' })
  },
}

// 章节管理API模拟
export const mockChapterApi = {
  getChapters: async (params: any) => {
    await delay(600)
    let filtered = [...mockChapters]

    // 按小说ID过滤
    if (params?.novelId) {
      filtered = filtered.filter((c) => c.novelId === params.novelId)
    }
    // 按状态过滤
    if (params?.status) {
      filtered = filtered.filter((c) => c.status === params.status)
    }
    // 按关键字搜索
    if (params?.keyword) {
      const kw = params.keyword.toLowerCase()
      filtered = filtered.filter((c) => c.title.toLowerCase().includes(kw))
    }
    // 排序
    filtered.sort((a, b) => a.number - b.number)

    const page = params?.page || 1
    const pageSize = params?.pageSize || 10
    const start = (page - 1) * pageSize
    const items = filtered.slice(start, start + pageSize)
      .map(c => ({
        ...c,
        novelTitle: mockNovels.find(n => n.id === c.novelId)?.title || '',
      }))

    return createMockResponse({
      items,
      total: filtered.length,
      page,
      pageSize,
      totalPages: Math.ceil(filtered.length / pageSize),
      hasNext: page * pageSize < filtered.length,
      hasPrev: page > 1,
    })
  },

  getChapter: async (id: string) => {
    await delay(400)
    const chapter = mockChapters.find((c) => c.id === id)
    if (!chapter) throw new Error('章节不存在')
    return createMockResponse({
      ...chapter,
      novelTitle: mockNovels.find(n => n.id === chapter.novelId)?.title || '',
    })
  },

  createChapter: async (data: any) => {
    await delay(700)
    const newChapter = {
      id: `c_mock_${Date.now()}`,
      ...data,
      wordCount: data.content ? data.content.length : 0,
      status: data.status || 'draft',
      novelTitle: mockNovels.find(n => n.id === data.novelId)?.title || '',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }
    mockChapters.push(newChapter)
    return createMockResponse(newChapter)
  },

  updateChapter: async (id: string, data: any) => {
    await delay(500)
    const index = mockChapters.findIndex((c) => c.id === id)
    if (index === -1) throw new Error('章节不存在')

    mockChapters[index] = {
      ...mockChapters[index],
      ...data,
      wordCount: data.content ? data.content.length : mockChapters[index].wordCount,
      updatedAt: new Date().toISOString(),
    }

    return createMockResponse({
      ...mockChapters[index],
      novelTitle: mockNovels.find(n => n.id === mockChapters[index].novelId)?.title || '',
    })
  },

  updateChapterStatus: async (id: string, status: string) => {
    await delay(400)
    const index = mockChapters.findIndex((c) => c.id === id)
    if (index === -1) throw new Error('章节不存在')

    mockChapters[index].status = status
    mockChapters[index].updatedAt = new Date().toISOString()

    return createMockResponse({
      ...mockChapters[index],
      novelTitle: mockNovels.find(n => n.id === mockChapters[index].novelId)?.title || '',
    })
  },

  deleteChapter: async (id: string) => {
    await delay(400)
    const index = mockChapters.findIndex((c) => c.id === id)
    if (index === -1) throw new Error('章节不存在')

    mockChapters.splice(index, 1)
    return createMockResponse({ message: '删除成功' })
  },

  batchUpdateStatus: async (ids: string[], status: string) => {
    await delay(600)
    ids.forEach((id) => {
      const chapter = mockChapters.find((c) => c.id === id)
      if (chapter) {
        chapter.status = status
        chapter.updatedAt = new Date().toISOString()
      }
    })
    return createMockResponse({ message: `已更新 ${ids.length} 个章节状态` })
  },

  batchDelete: async (ids: string[]) => {
    await delay(600)
    ids.forEach((id) => {
      const index = mockChapters.findIndex((c) => c.id === id)
      if (index !== -1) mockChapters.splice(index, 1)
    })
    return createMockResponse({ message: `已删除 ${ids.length} 个章节` })
  },
}

// 扩展小说API：获取简单列表
export const mockNovelSimpleApi = {
  getSimpleList: async () => {
    await delay(300)
    return createMockResponse(
      mockNovels.map((n) => ({ id: n.id, title: n.title }))
    )
  },
}

// 导出所有模拟API
export const mockApi = {
  auth: mockAuthApi,
  dashboard: mockDashboardApi,
  novel: { ...mockNovelApi, ...mockNovelSimpleApi },
  chapter: mockChapterApi,
  system: mockSystemApi,
  user: mockUserApi,
}

export default mockApi